import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type LayoutType = 'grid' | 'kanban' | 'map' | 'calendar' | 'charts';

interface LayoutPreferences {
  // Store layout preference for each entity
  layouts: Record<string, LayoutType>;
  // Store status field for kanban view for each entity
  kanbanFields: Record<string, string>;

  // Actions
  setLayout: (entityName: string, layout: LayoutType) => void;
  getLayout: (entityName: string) => LayoutType;
  setKanbanField: (entityName: string, field: string) => void;
  getKanbanField: (entityName: string) => string | undefined;
}

export const useLayoutPreferences = create<LayoutPreferences>()(
  persist(
    (set, get) => ({
      layouts: {},
      kanbanFields: {},

      setLayout: (entityName, layout) =>
        set(state => ({
          layouts: {
            ...state.layouts,
            [entityName]: layout
          }
        })),

      getLayout: (entityName) =>
        get().layouts[entityName] || 'grid',

      setKanbanField: (entityName, field) =>
        set(state => ({
          kanbanFields: {
            ...state.kanbanFields,
            [entityName]: field
          }
        })),

      getKanbanField: (entityName) =>
        get().kanbanFields[entityName]
    }),
    {
      name: 'layout-preferences'
    }
  )
);
